import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const InsertRowAbove = (props) => (
  <SvgIcon width="20.477" height="21.16" viewBox="0 0 20.477 21.16" {...props}>
    <g transform="translate(0.01)">
      <path
        d="M62.42,402.865a3.579,3.579,0,0,1,.084-.405,2.019,2.019,0,0,1,1.645-1.45,1.878,1.878,0,0,1,.346-.027h13.6a2.048,2.048,0,0,1,2.038,1.678,2.17,2.17,0,0,1,.035.407q0,1.488,0,2.976a.123.123,0,0,0,.059.117,6.162,6.162,0,0,1,2.163,2.62,5.887,5.887,0,0,1,.469,1.762c.014.135.026.27.04.406v.56a.56.56,0,0,0-.012.073,5.628,5.628,0,0,1-.153,1.056,6.172,6.172,0,0,1-3.555,4.229,5.948,5.948,0,0,1-1.73.458l-.406.041h-.573a.674.674,0,0,0-.08-.014,5.488,5.488,0,0,1-.95-.13,6.178,6.178,0,0,1-4.463-3.921,5.833,5.833,0,0,1-.344-1.613,6.725,6.725,0,0,1,0-.688c.005-.151.033-.3.052-.461H64.516c-.084,0-.168,0-.252-.012a2.049,2.049,0,0,1-1.76-1.466c-.037-.133-.056-.27-.084-.406ZM78.8,405.43v-2.384a.675.675,0,0,0-.7-.7H64.484a.674.674,0,0,0-.7.7v5.433a.675.675,0,0,0,.7.7h6.437c.041,0,.069,0,.087-.051a6.2,6.2,0,0,1,3.322-3.539,6.021,6.021,0,0,1,2.089-.5,5.239,5.239,0,0,1,1.411.1C78.151,405.255,78.471,405.346,78.8,405.43Zm2.73,5.791a4.769,4.769,0,1,0-1.425,3.407A4.767,4.767,0,0,0,81.531,411.221Z"
        transform="translate(-62.43 -396.203)"
      />
      <path
        d="M65.856,51a.614.614,0,0,0,.049.062l3.28,3.28a.679.679,0,0,0,.064.051l-.01.02H62.43V54.4a.448.448,0,0,0,.052-.039l3.308-3.308A.452.452,0,0,0,65.829,51Z"
        transform="translate(-62.44 -51)"
      />
      <path
        d="M865.409,905.34H862.68v-1.361h2.726V901.25h1.363v2.726H869.5v1.363h-2.726v2.729h-1.363Z"
        transform="translate(-851.766 -889.643)"
      />
    </g>
  </SvgIcon>
);
export default InsertRowAbove;



// WEBPACK FOOTER //
// ./src/common/icons/InsertRowAbove/index.tsx